/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I3_LabelInputs */

const tr_kullanim_s2_i3_label = /** @type {(inputs: Kullanim_S2_I3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üçüncü Taraf Hizmetleri:`)
};

const en_kullanim_s2_i3_label = /** @type {(inputs: Kullanim_S2_I3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-party services:`)
};

const de_kullanim_s2_i3_label = /** @type {(inputs: Kullanim_S2_I3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienste Dritter:`)
};

const ru_kullanim_s2_i3_label = /** @type {(inputs: Kullanim_S2_I3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуги третьих лиц:`)
};

/**
* | output |
* | --- |
* | "Third-party services:" |
*
* @param {Kullanim_S2_I3_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i3_label = /** @type {((inputs?: Kullanim_S2_I3_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I3_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i3_label(inputs)
	if (locale === "de") return de_kullanim_s2_i3_label(inputs)
	if (locale === "ru") return ru_kullanim_s2_i3_label(inputs)
	return tr_kullanim_s2_i3_label(inputs)
});